import { initializeApp } from 'firebase/app';
import { getDatabase } from 'firebase/database';
import { getStorage } from 'firebase/storage';
import { getAuth, GoogleAuthProvider } from 'firebase/auth';

// Use an auth domain that is SAME-ORIGIN with wherever the app is served, so
// signInWithRedirect works inside an installed iOS PWA (Safari/ITP drops the
// session on a cross-domain auth handler → endless login loop). mie.co.il and the
// *.web.app site both serve Firebase's /__/auth/ handler; fall back to the default
// on localhost (where popup is used and cross-domain is fine).
const SAME_ORIGIN_AUTH_HOSTS = ['mie.co.il', 'kfirmiller-5fb5e.web.app', 'kfirmiller-5fb5e.firebaseapp.com'];
const authDomain =
    (typeof window !== 'undefined' && SAME_ORIGIN_AUTH_HOSTS.includes(window.location.hostname)
        ? window.location.hostname
        : 'kfirmiller-5fb5e.firebaseapp.com');

const firebaseConfig = {
    apiKey: 'AIzaSyBz4DvihVyU3rl7FXlCmB8Refzx6SrZn3U',
    authDomain,
    databaseURL: 'https://kfirmiller-5fb5e.firebaseio.com',
    projectId: 'kfirmiller-5fb5e',
    storageBucket: 'kfirmiller-5fb5e.firebasestorage.app',
    messagingSenderId: '594409333755',
    appId: '1:594409333755:web:fec67d9c8e333b8d5b615e',
};

const app = initializeApp(firebaseConfig);
export const db = getDatabase(app);
export const storage = getStorage(app);
export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();
// always show the account chooser (so after logout you can pick a different account,
// instead of Google silently re-using the previous one)
googleProvider.setCustomParameters({ prompt: 'select_account' });
export default app;
